import React from "react";
import Fade from "react-reveal/Fade";
import { NavLink } from "react-router-dom";
import { useGetProductListQuery } from "../../utils/api/product/product.api";
import BestSellerCatalogGrid from "./BestSellerCatalogGrid";
import type { Product } from "../../utils/api/product/product.type";

const LIMIT = 4;

/**
 * Accueil : aperçu des premiers produits + lien vers le catalogue (`/produits`).
 */
const NosProduitsSection = () => {
  const { data, isLoading } = useGetProductListQuery({
    page: 1,
    limit: LIMIT,
  });

  const products: Product[] = data?.results ?? [];

  return (
    <section
      className="best-sellers-section best-sellers-section--nos-produits px-lg-3"
      aria-labelledby="nos-produits-heading"
    >
      <div className="best-sellers-section-container">
        <Fade bottom>
          <header className="best-sellers-section-header">
            <h2
              id="nos-produits-heading"
              className="best-sellers-section-title text-center"
            >
              NOS PRODUITS
            </h2>
          </header>
        </Fade>
        {isLoading ? (
          <BestSellerCatalogGrid
            products={[]}
            isLoading
            skeletonCount={LIMIT}
          />
        ) : (
          <>
            {products.length > 0 ? (
              <BestSellerCatalogGrid products={products} isLoading={false} />
            ) : (
              <p className="best-sellers-section-empty text-center mb-0">
                Aucun produit à afficher pour le moment.
              </p>
            )}
            <div className="best-sellers-section-see-more-wrap text-center">
              <NavLink
                to="/produits"
                className="best-sellers-section-see-more"
              >
                Voir plus
              </NavLink>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default NosProduitsSection;
